import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { ProjectGetter } from '@/store/project/project.module';
import { Project, ProjectForm } from '@/store/project/project.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';
import ProjectFormComponent from '@/components/project/create/createComponents/projectForm/ProjectForm.vue';

export default defineComponent({
  name: 'ProjectModalComponent',
  components: {
    BaseModalComponent,
    ProjectFormComponent
  },
  props: {
    projectId: {
      type: Number,
      required: true,
    },
  },
  emits: [
    'validated'
  ],
  setup: (props, context) => {
    const store = useStore();
    const projectModal = ref<InstanceType<typeof BaseModalComponent>>();
    const form = ref<InstanceType<typeof ProjectFormComponent>>();
    const isLoading = computed<boolean>(() => store.getters[ProjectGetter.STATUS] === 'init' || store.getters[ProjectGetter.STATUS] === 'loading');

    const project = computed<Project | undefined>(() => store.getters[ProjectGetter.BY_ID](props.projectId));
    const projectForm = computed<ProjectForm>(() => {
      return {
        name: project.value?.name ?? '',
        description: project.value?.description,
        projectTypeId: project.value?.projecType.id,
        fiscalYearId: project.value?.fiscalYear.id,
        provinceId: project.value?.province.id,
      };
    });

    // show modal
    const show = () => {
      projectModal.value?.show();
    };

    // hide modal
    const hide = () => {
      projectModal.value?.hide();
    };

    const submitClick = () => {
      form.value?.submitForm();
    };

    const validated = (projectData: ProjectForm) => {
      context.emit('validated', projectData);
      hide();
    };

    const clearForm = () => {
      form.value?.clearForm();
    };

    return {
      projectModal,
      form,
      isLoading,
      projectForm,
      show,
      hide,
      submitClick,
      validated,
      clearForm,
    };
  },
});
